/**
 * Award image URL map. Migrated from Vite `import.meta.glob('?url')` to static
 * /public path strings — call sites (`awardImages['ieee.webp']`) are unchanged.
 */
export const awardImages: Record<string, string> = {
  'FWD.webp': '/awards/FWD.webp',
  'elmehwar.webp': '/awards/elmehwar.webp',
  'fcis-documentary.webp': '/awards/fcis-documentary.webp',
  'grand.jpg': '/awards/grand.jpg',
  'helipolis-post.webp': '/awards/helipolis-post.webp',
  'huawei-ambassador-egypt.webp': '/awards/huawei-ambassador-egypt.webp',
  'huawei-annual-ambassador.webp': '/awards/huawei-annual-ambassador.webp',
  'huawei-ict-2022.webp': '/awards/huawei-ict-2022.webp',
  'huawei-ict-2025.webp': '/awards/huawei-ict-2025.webp',
  'huaweistory.webp': '/awards/huaweistory.webp',
  'icicis.webp': '/awards/icicis.webp',
  'ieee.webp': '/awards/ieee.webp',
  'magazine.webp': '/awards/magazine.webp',
  'medal.webp': '/awards/medal.webp',
  'omac.webp': '/awards/omac.webp',
  'seeds.webp': '/awards/seeds.webp',
  'story.webp': '/awards/story.webp',
  'zdare.webp': '/awards/zdare.webp',
}
